import React from "react";

const IhealContext = React.createContext();

export default IhealContext;
